angular.module('shbdeployer.app').factory('Project', ProjectFactory);

function ProjectFactory($resource, API_ENDPOINT_PROJECTS) {
  return $resource(
    API_ENDPOINT_PROJECTS + '/:id/:action',
    {},
    {
      get: { method: 'GET', params: { id: '@id' } },
      query: { method: 'GET', isArray: true },
      remove: { method: 'DELETE', params: { id: '@id' } },
      status: { method: 'GET', params: { id: '@id', action: 'status' } },
    }
  );
}
